export class ClearMessages {
    public static readonly type = '[MessagingState] Clear messages';
}
